import { render, staticRenderFns } from "./apiPost.vue?vue&type=template&id=230a6f39&"
import script from "./apiPost.vue?vue&type=script&lang=js&"
export * from "./apiPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports